import React from 'react';
import { connect } from 'react-redux';

class FormDropdown extends React.Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        jQuery("body").on("mouseleave", "#dropdownMenuButton", function () {
            jQuery(this).tooltip('hide').attr('data-original-title', $(this).attr('data-title'));
        });

        jQuery("body").on("mouseenter", "#dropdownMenuButton", function () {
            jQuery(this).tooltip('hide').attr('data-original-title', $(this).attr('data-title'))
            jQuery(this).tooltip('show');
        });
    }


    render() {
        return (
            <div className={this.props.classes ?? ""}>
                <div className="dropdown timeline-dropdown-feedbacks">
                    <input
                        type="hidden"
                        className="timelineFeedbackHiddenInput"
                        value={this.props.title}
                    />
                    <button
                        data-second-toggle="tooltip"
                        data-placement="top"
                        data-title={this.props.tooltip ?? ''}
                        className={"dropdown-toggle second-input input-primary w-100 d-flex form-dropdown d-flex align-items-center " + this.props.buttonClasses ?? ""} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-offset={this.props.offset ?? null}>
                        {this.props.title}
                    </button>
                    <div className={"dropdown-menu dropdown-menu-right " + this.props.menuClasses ?? ""} aria-labelledby="dropdownMenuButton">
                        {this.props.items.filter(item => (item && item.text)).map((item, index) => {
                            return <a style={{ userSelect: "none" }} className="dropdown-item d-flex cursor-pointer" onClick={this.props.itemOnClickFunction ?? null} id={item.id ?? null} href={item.link ?? null} key={index}>{item.text ?? null}</a>
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(FormDropdown);
